import type { ChartData, ChartType } from 'chart.js';

export function getTotalCountFromChartData(chartData: ChartData<ChartType, number[], unknown>) {
    return chartData.datasets[0].data.reduce((a, b) => a + b, 0);
}
